import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";

const useStyles = makeStyles(theme => ({
	chatContainer: {
		flex: 1,
		// backgroundColor: "#eee",
		padding: theme.spacing(0), //Aqui ele ajusta espaço na tela de ticket
		height: `calc(100% - 48px)`,
		overflowY: "hidden",
	},

	chatPapper: {
		// backgroundColor: "red",
		display: "flex",
		height: "100%",
	},

	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
	},
	welcomeMsg: {
		backgroundColor: theme.palette.boxticket, //DARK MODE PLW DESIGN//
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
		padding: theme.spacing(3),
	},
	// ✅ NUEVOS ESTILOS PARA MEJOR UX (igual que CHATS)
	logoContainer: {
		marginBottom: theme.spacing(3),
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	logoImage: {
		maxWidth: "450px",
		maxHeight: "450px",
		width: "auto",
		height: "auto",
		objectFit: "contain",
		imageRendering: "auto", // ✅ Mantener calidad al escalar
	},
	welcomeText: {
		marginBottom: theme.spacing(1),
		textAlign: "center",
		fontSize: "1.5rem", // ✅ Texto más grande
	},
	subtitleText: {
		marginBottom: theme.spacing(2),
		textAlign: "center",
		color: theme.palette.text.secondary,
		fontSize: "1rem", // ✅ Texto más grande
	},
	actionButton: {
		marginTop: theme.spacing(2),
	},
}));

const logo = `${process.env.REACT_APP_BACKEND_URL || window.location.origin}/public/logotipos/login.png`;
const randomValue = Math.random(); // Generate a random number
  
const logoWithRandom = `${logo}?r=${randomValue}`;

const TicketsCustom = () => {
	const classes = useStyles();
	const { ticketId } = useParams();

	return (
		<div className={classes.chatContainer}>
			<div className={classes.chatPapper}>
				<Grid container spacing={0}>
					<Grid item xs={3} className={classes.contactsWrapper}> {/* ✅ REDUCIDO: De xs={4} a xs={3} - Reduce ancho del contenedor de tickets */}
						<TicketsManager />
					</Grid>
					<Grid item xs={9} className={classes.messagesWrapper}> {/* ✅ AJUSTADO: De xs={8} a xs={9} - Aumenta ancho del área de mensajes */}
						{ticketId ? (
							<>
								<Ticket />
							</>
						) : (
							<Paper square variant="outlined" className={classes.welcomeMsg}>
								{/* ✅ LOGO ADAPTABLE CON MEDIDAS CORRECTAS */}
								<div className={classes.logoContainer}>
									<img 
										className={classes.logoImage}
										src={logoWithRandom} 
										alt={`${(typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_NAME_SYSTEM : 'Sistema'}`} 
									/>
								</div>
								
								{/* ✅ MENSAJE PRINCIPAL */}
								<Typography variant="h6" color="textPrimary" className={classes.welcomeText} style={{ fontWeight: "bold" }}>
									Bienvenido a tu modulo de chat
								</Typography>
								
								{/* ✅ MENSAJE SUBLIMINAL */}
								<Typography variant="body2" color="textSecondary" className={classes.subtitleText}>
									Puedes abrir un nuevo chat o esperar a que se te asigne
								</Typography>
							</Paper>
						)}
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default TicketsCustom;
